import dayjs from 'dayjs'

export const formatDate = (datetimeStr) => {
  if (!datetimeStr || datetimeStr === 'Indefinite') {
    return datetimeStr
  }
  return dayjs(datetimeStr).format('M/DD/YY')
}
